import * as React from 'react';
import { UnityPortal } from 'web_unity_engine';
import ENV from '../../base/env';
import UnityPreloader from './UnityPreloader';
import './WorkoutView.scss';

export const WorkoutView: React.FC = () => {
  return (
    <div className="view workout-view" id={`wrapper-${ENV.UnityCanvasId}`}>
      <UnityPortal canvasId={ENV.UnityCanvasId} className="unity-view" />
      <UnityPreloader />
    </div>
  );
};

export default WorkoutView;
